import { render, staticRenderFns } from "./GoalSettingOutcomeGoalRow.vue?vue&type=template&id=5cfd608a&scoped=true&"
import script from "./GoalSettingOutcomeGoalRow.vue?vue&type=script&lang=js&"
export * from "./GoalSettingOutcomeGoalRow.vue?vue&type=script&lang=js&"
import style0 from "./GoalSettingOutcomeGoalRow.vue?vue&type=style&index=0&id=5cfd608a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfd608a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VRow,VSwitch})
